import { render, staticRenderFns } from "./InputFirmador.vue?vue&type=template&id=b26ff10c&"
import script from "./InputFirmador.vue?vue&type=script&lang=js&"
export * from "./InputFirmador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports